
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Neue Schriftart</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>Füllen Sie bitte alle Felder aus, um einen neuen Kunden hinzuzufügen.</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-text>
                          Neue Schriftart
                          <h3 class="headline">Laden Sie eine Schriftart hoch.</h3>
                          <v-text-field
                            class="pt-5"
                            autofocus
                            placeholder="Name"
                            outlined
                            label="Name"
                            v-model="font.name"
                          ></v-text-field>

                          <v-text-field
                            placeholder="0"
                            outlined
                            label="Externe ID"
                            v-model="font.externalId"
                          ></v-text-field>

                          <v-file-input
                            outlined
                            show-size
                            accept=".ttf, .woff, .woff2"
                            label="Schriftart"
                            v-model="fontFile"
                            :loading="uploadingState == 2"
                            :success="uploadingState == 1"
                            ref="file"
                            @change="uploadFont"
                          ></v-file-input>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                          <v-btn large color="primary" @click="create">Speichern</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>

                    <v-col
                      style="font-family: UploadedFont, Arial; font-size:2em; line-height: 2.2em"
                      v-if="font.url"
                    >
                      <h1>A B C D E F G H I K L M N O P Q R S T U V W X Y Z</h1>
                      <h1>a b c d e f h i j k l m n o p q r s t u v w x y z</h1>
                      <h1>0 1 2 3 4 5 6 7 8 9 0</h1>
                      <h1>! " § $ % & / ( ) = ? € @ ; : - \</h1>

                      <p>
                        Á á À à Ã ã Ä ä Â â Ǎ ǎ Å å Ą ą
                        B b Ḃ ḃ C c Ć ć Ĉ ĉ Č č Ċ ċ D d Ď ď Ḋ ḋ Ḑ ḑ E e É é È è Ë ë Ê ê Ě ě Ė ė Ę ę
                        F f Ḟ ḟ G g Ǵ ǵ Ĝ ĝ Ǧ ǧ Ġ ġ Ģ ģ H h Ḧ ḧ Ĥ ĥ Ȟ ȟ Ḣ ḣ I i Í í Ì ì Ĩ ĩ Ï ï Î î Ǐ ǐ Į į
                        J j Ĵ ĵK k Ḱ ḱ Ǩ ǩ Ķ ķ L l Ĺ ĺ Ľ ľ Ļ ļ M m Ḿ ḿ Ṁ ṁ N n Ń ń Ǹ ǹ Ñ ñ Ň ň Ṅ ṅ Ņ ņ O o Ó ó Ò ò Õ õ Ö ö Ô ô Ǒ ǒ Ȯ ȯ Ǫ ǫ
                        P p Ṕ ṕ Ṗ ṗ R r Ŕ ŕ Ř ř Ṙ ṙ Ŗ ŗ S s Ś ś Ŝ ŝ Š š Ṡ ṡ Ș ș T t ẗ Ť ť Ṫ ṫ Ț ț U u Ú ú Ù ù Ũ ũ Ü ü Û û Ǔ ǔ Ů ů Ų ų
                        W w Ẃ ẃ Ẁ ẁ Ẅ ẅ Ŵ ŵ ẘ X x Ẍ ẍ Ẋ ẋ Y y Ý ý Ÿ ÿ ẙ Ẏ ẏ Z z Ź ź Ẑ ẑ Ž ž Ż ż
                      </p>
                      <p></p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import FontService from "@/services/FontService";

export default {
  name: "dashboard",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    error: null,
    fontFile: null,
    uploadingState: 0,
    font: {
      name: null,
      externalId: null,
      url: null
    }
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    async uploadFont(file) {
      this.uploadingState = 2;
      let formData = new FormData();
      formData.set("file", this.fontFile);
      try {
        let fileUrl = (await FontService.upload(formData)).data;
        this.font.url = fileUrl;
        this.font.name = this.fontFile.name
        this.loadFont();
        
      } catch (err) {
        this.uploadingState = 0;
      }
    },

    loadFont() {
      let fontFace = new FontFace(
        "UploadedFont",
        "url('" + this.font.url + "')"
      );
      fontFace
        .load()
        .then(face => {
          document.fonts.add(face);
          this.uploadingState = 1;
        })
        .catch(err => {
          throw err;
        });
    },
    async create() {
      try {
        this.loading = true;

        //add user
        try {
          let payload = this.font;
          let response = await FontService.create(payload);
        } catch (err) {
          alert(err.message);
        }

        this.loading = false;
        router.push({
          name: "Fonts"
        });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },
    async refresh() {
      this.loading = true;
      try {
        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

